import { StyleSheet, ScrollView, View, Dimensions, Pressable, Linking, Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import Icon from "react-native-vector-icons/Ionicons";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "./helpers/PlaceColors";
import { BasePage } from "./helpers/BasePage";
import { FindifyHTMLRender } from "./helpers/FindifyHTMLRender";
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { getTranslatedString } from "./helpers/FindifyTranslatedString";
import { FindifyFooterLogo, BottomNavigationPadding } from "./components/FindifyNavigation";
import { FindifyToast } from "./components/FindifyToast";
import { useTranslation } from "react-i18next";
import { getApiFromModule } from "./helpers/GetContentsByModule";
import { getFeaturedImageUrl } from "./helpers/DetailsHelpers";

const makePlaceActionIcon = (action: Function, logo: string, findifyDataContext: any) => {
    return <Pressable onPress={() => action()}>
        <Icon style={{ color: PlaceColors(findifyDataContext).text.get() }} name={logo} size={30} />
    </Pressable>
}


export const openSocial = (navigation: any, line: any, t: Function) => {
    let url: string = line?.value ?? "";
    switch (line.type) {
        case 'phone':
            url = 'tel:' + url;
            break;
        case 'email':
            url = 'mailto:' + url;
            break;
        case 'location':
        case 'facebook':
        case 'instagram':
        case 'website':
        default:
            break;
    }
    if (line.value === "") {
        FindifyToast({
            type: 'error',
            title: t('schedule.error_open_social'),
            message: t('schedule.error_open_social_sucessfully'),
        })
    } else {
        if (url.startsWith('https://') || url.startsWith('http://')) {
            if (Platform.OS === "web" && typeof window !== "undefined") {
                window.open(url, "_blank", "noopener,noreferrer");
                return;
            }
            navigation.push('WebViewPage', { url: url, title: line.label });
        } else {
            Linking.openURL(url).catch((err) => {
                FindifyToast({
                    type: 'error',
                    title: t('schedule.error_open_social'),
                    message: t('schedule.error_open_social_sucessfully'),
                })
            });
        }
    }
}
export const PlaceInfoTab = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const findifyDataContext = useContext(FindifyDataContext);
    const contentsApi = getApiFromModule('contents', findifyDataContext);
    const [infoContent, setInfoContent] = useState<any>({});
    const { t } = useTranslation();
    useEffect(() => {
        contentsApi.get(findifyDataContext?.workspace?.app_settings?.place_info, null, null).then((res: any) => {
            setInfoContent(res);
        })
    }, [])
    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={[styles.container, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
            <FindifySimpleHeader navigation={navigation}
                title={getTranslatedString(infoContent?.name, findifyDataContext)}
                actions={undefined}
                image={getFeaturedImageUrl(infoContent)} />

            {(findifyDataContext.workspace?.app_settings?.socials_lines?.length ?? 0) > 0 &&
                <View style={{
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    justifyContent: 'space-around',
                    backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(80),
                }}>
                    {findifyDataContext.workspace?.app_settings?.socials_lines.map((line: any, index: number) => {
                        return makePlaceActionIcon(() => openSocial(navigation, line, t), line?.icon, findifyDataContext);
                    })}
                </View>
            }
            <View style={{ padding: 10, paddingBottom: BottomNavigationPadding, }}>

                <FindifyHTMLRender
                    baseStyles={{
                        color: PlaceColors(findifyDataContext).text.get(),
                    }}
                    htmlCode={getTranslatedString(infoContent?.description, findifyDataContext)} />
                <FindifyFooterLogo findifyDataContext={findifyDataContext} />
            </View>
        </ScrollView>
    </BasePage>;
};


const styles = StyleSheet.create({

    container: {
        height: '100%',
        width: '100%',
    },
    map: {
        flex: 1
    }

})
